export const sanitizeForFilename = (string) => {
  return string.replace(/[^a-z0-9-_áéíóúÁÉÍÓÚñÑ.]/gi, '_');
};
